// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface PopularCategoriesApiParameter extends ApiParameter {
    count: string;
    categories: string[];
}

interface CategoryModel {
    id: string;
    name: string;
    shortDescription: string;
    imageAltText: string;
    imagePath: string;
    categoryPath: string;
}

export interface PopularCategoriesCollectionModel extends BaseModel {
    categories: CategoryModel[];
}

const popularCategoriesUrl = "api/mcmc/category/popularCategories";

export async function getPopularCategories(parameter: PopularCategoriesApiParameter) {
    const popularCategoriesCollection = await get<PopularCategoriesCollectionModel>(
        `${popularCategoriesUrl}`,
        parameter,
    );

    return popularCategoriesCollection;
}
